import React from 'react';
import '../StockNewsWidget/StockNewsWidget.css';
import { formatAdminDateTime } from '../../utils/datetime';

const formatDateTime = (dateString) => formatAdminDateTime(dateString, '');

const StockAnnouncementsWidget = ({ events = [], loading = false }) => {
    const handleClick = (event) => {
        if (event.link) {
            window.open(event.link, '_blank');
        }
    };

    return (
        <div className="sa-news-widget">
            <div className="sd-section-header">
                <div className="sd-section-icon orange">
                    <span className="material-symbols-outlined">campaign</span>
                </div>
                <h3 className="sd-section-title">Corporate Announcements</h3>
            </div>

            <div className="sa-widget-body">
                <div className="sa-news-list">
                    {loading ? (
                        <p className="sa-news-loading">Loading announcements...</p>
                    ) : events?.length > 0 ? events.map((event, idx) => (
                        <div
                            className="sa-event-item"
                            key={event.id || idx}
                            onClick={() => handleClick(event)}
                            style={{ cursor: event.link ? 'pointer' : 'default' }}
                        >
                            <div className="sa-event-content">
                                <p>
                                    {event.description || event.subject || event.title}
                                </p>
                                <span className="sa-event-date">
                                    {formatDateTime(event.pub_date || event.broadcastdate || event.date || event.news_date || event.created_at)}
                                </span>
                            </div>
                            {event.link && (
                                <span className="material-symbols-outlined" style={{ fontSize: 22, color: '#dc2626', marginTop: 2, flexShrink: 0 }}>
                                    picture_as_pdf
                                </span>
                            )}
                        </div>
                    )) : (
                        <p className="sa-news-empty">No corporate announcements currently.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StockAnnouncementsWidget;
